/*
 * @Description:
 * @Author: Mankeung
 * @Date: 2021-07-17 20:42:45
 * @LastEditors: Mankeung
 * @LastEditTime: 2021-07-20 16:30:10
 */
export default [
    {
        path: "WechatAppletList",
        name: "WECHAT_APPLET_LIST",
        meta: {
            title: "小程序应用列表",
            icon: "",
            cache:'showCache',
            isNav: true,
        },
        component: () =>
            import ("@/views/WechatApplet/appList.vue"),
    },

    {
        path: "wechatAppAdvertising",
        name: "WECHAT_APP_ADVERTISING",
        meta: {
            title: "小程序应用-广告",
            icon: "",
            isNav: true,
        },
        component: () =>
            import("@/views/WechatApplet/appAdvertising.vue"),
    },
    {
        path: "wechatKeywordList",
        name: "WECHAT_KEYWORD_LIST",
        meta: {
            title: "小程序关键字配置",
            icon: "",
            isNav: true,
        },
        component: () =>
            import("@/views/WechatApplet/keywordList.vue"),
    },

]